import React from "react";
import CardTrio from "../../components/CardTrio/CardTrio";
import { ProgrammingLanguage } from "../../model/common";
import { SanityMake } from "../../model/makes";
import MakeCard from "../MakeCard/MakeCard";

const FeaturedMakes = ({
  node: { items, preferredEditor, sequence = false }
}: {
  node: {
    items: SanityMake[];
    preferredEditor?: ProgrammingLanguage;
    sequence?: boolean;
  };
}) => (
  <CardTrio sequence={sequence}>
    {items &&
      items.map(featured => (
        <MakeCard
          key={featured._id}
          make={featured}
          preferredEditor={preferredEditor}
        />
      ))}
  </CardTrio>
);

export default FeaturedMakes;
